import { memo, useMemo } from 'react';
import { EntityTypes } from '@wg/wows-entities/const';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { Message } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';

import AnimatedNumber from '~/UIKit/AnimatedNumber/AnimatedNumber';

import styles from './Result.scss';

export const RESULTS = {
  WIN: 'WIN',
  DEFEAT: 'DEFEAT',
  DRAW: 'DRAW',
  FAILED_PREPARATION: 'FAILED_PREPARATION',
} as const;

interface ResultProps {
  title?: string;
  result?: string;
  rating: number;
  ratingDelta: number;
  ready?: boolean;
  reward: number;
}

const Result = ({ title, result, rating, ratingDelta, ready, reward }: ResultProps) => {
  const highlightClass = useMemo(() => {
    switch (result) {
      case RESULTS.WIN:
        return styles.winHighlight;
      case RESULTS.DEFEAT:
        return styles.defeatHighlight;
      case RESULTS.DRAW:
        return styles.drawHighlight;
      default:
        return '';
    }
  }, [result]);

  const headerText = title ?? t('Получено за морское сражение');

  return (
    <div className={styles.results}>
      <div className={`${styles.highlight} ${highlightClass}`} />

      <span className={styles.resultsHeader}>{headerText}</span>

      {ready === false && ( // === false is important!
        <span className={styles.infoMessage}>
          <Message type="info" style="inline">
            {t('Награда будет начислена в ближайшее время')}
          </Message>
        </span>
      )}

      <div className={styles.resultSides}>
        <div className={styles.resultSide}>
          <div className={styles.resultRow}>
            <span className={styles.resultValue}>{rating}</span>
            <div className={styles.resultDelta}>
              {'+'}
              <AnimatedNumber value={Number(ratingDelta ?? 0)} duration={0.6} formatter={(n) => String(n)} />
            </div>
          </div>
          <span className={styles.resultLabel}>{t('Рейтинг')}</span>
        </div>

        <div className={styles.resultSide}>
          <WoWSEntity
            type={EntityTypes.CURRENCY}
            id="clan_resource"
            amount={reward}
            presentation={{
              bindTooltip: true,
              withTooltip: true,
              hideReceiveText: true,
              hideSpendText: true,
            }}
          >
            <div className={styles.resultRow}>
              <span className={styles.resultValue}>{reward}</span>
              <div className={styles.resultIcon} />
            </div>
            <span className={styles.resultLabel}>{t('Награда')}</span>
          </WoWSEntity>
        </div>
      </div>
    </div>
  );
};

export default memo(Result);
